
export default {
  payslips:[],
  payslipsender:[],
}
